// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__k6M6g","plain":"Dropdown_plain__eyEXV","placeholder":"Dropdown_placeholder____HHr"};